<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-edit"
      @click="openDialog(true, null)"
      >新增</el-button
    >
    <el-table :data="list" border size="small" style="width: 1051px">
      <el-table-column label="ID" align="center" prop="id" width="140">
      </el-table-column>

      <el-table-column prop="name" label="名称" align="center" width="180">
      </el-table-column>

      <el-table-column label="主sdk" align="center" prop="mainSdk" width="120">
        <template slot-scope="scope">
          {{ scope.row.mainSdk }}
        </template>
      </el-table-column>

      <el-table-column
        label="主sdk的参数"
        show-overflow-tooltip
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="
              scope.row.mainSdkParams != 'null' &&
              scope.row.mainSdkParams != '{}' &&
              scope.row.mainSdkParams != ''
            "
            placement="right"
            trigger="hover"
            width="600"
          >
            <div style="margin-top: 5px">
              <el-input
                type="textarea"
                rows="15"
                :value="string2FormatCode(scope.row.mainSdkParams)"
                readonly
                placeholder=""
              >
              </el-input>
            </div>

            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        label="采用测试支付金额"
        align="center"
        prop="mainSdk"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isUseTestPayAmount ? "是" : "" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="独立支付方式的参数"
        show-overflow-tooltip
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="
              scope.row.payWays != 'null' &&
              scope.row.payWays != '{}' &&
              scope.row.payWays != ''
            "
            placement="right"
            trigger="hover"
            width="600"
          >
            <div style="margin-top: 5px">
              <el-input
                type="textarea"
                rows="15"
                :value="string2FormatCode(scope.row.payWays)"
                readonly
                placeholder=""
              >
              </el-input>
            </div>

            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        label="额外属性"
        show-overflow-tooltip
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-popover
            v-if="
              scope.row.extra != 'null' &&
              scope.row.extra != '{}' &&
              scope.row.extra != ''
            "
            placement="right"
            trigger="hover"
            width="600"
          >
            <div style="margin-top: 5px">
              <el-input
                type="textarea"
                rows="15"
                :value="string2FormatCode(scope.row.extra)"
                readonly
                placeholder=""
              >
              </el-input>
            </div>

            <el-button slot="reference" size="small" icon="el-icon-view"
              >查看</el-button
            >
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <span
            class="link-button"
            style="color: red"
            @click="remove(scope.row)"
            >删除</span
          >
          <span class="link-button" @click="openDialog(false, scope.row)"
            >编辑</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data() {
    return {
      form: {
        action: "query",
        channel: {},
      },
      list: [],
    };
  },

  async created() {
    // 拉取渠道集合
    await this.loadList();
  },

  components: {},

  methods: {
    async loadList() {
      this.form.action = "query";
      await this.callApi();
    },

    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除渠道：${entry.name}`, {
          type: "warning",
        });
        this.form.action = "delete";
        this.form.channel = {
          id: entry.id,
        };
        await this.callApi();
      } catch (e) {}
    },

    async openDialog(isCreate, entry) {
      this.$dialogutil.open("EditChannelConfigDialog", {
        closedCallback: () => {
          this.loadList();
        },
        data: { isCreate: isCreate, oldData: entry },
      });
    },
    async callApi() {
      try {
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/manageChannels`,
            this.form,
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        this.list = resData.data.channels || [];
      } catch (e) {}
    },
    string2FormatCode(str) {
      let obj = JSON.parse(str);
      return JSON.stringify(obj, null, "    ");
    },
  },
};
</script>



<style lang="scss" scoped>
// /deep/ .el-table__row td {
//     padding: 3px 0;
// }

// /deep/ .el-table .cell {
//     line-height: 18px;
// }

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>
